module.exports = __webpack_public_path__ + "National2Web-Medium.eot?54ac864a36f67a9557cec84b4bbf3ee1";